import React from "react";

import { Clock } from "lucide-react";
import { Load } from "@/api/loads/getLoads";

type Props = {
  load: Load;
};

export const DateRange: React.FC<Props> = ({ load }) => {
  const formatDateTime = (date: Date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  const formatDateWindow = (startDate: Date | null, endDate: Date | null) => {
    if (!startDate || !endDate) return "Not Available";
    if (startDate && !endDate) return `After ${formatDateTime(startDate)}`;
    if (!startDate && endDate) return `Before ${formatDateTime(endDate)}`;
    return `${formatDateTime(startDate)} - ${formatDateTime(endDate)}`;
  };
  return (
    <React.Fragment>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm">
            Pickup Window: {formatDateWindow(load.pickupStart, load.pickupEnd)}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2 ml-6">
        <span className="text-sm text-muted-foreground">
          Drop-off Window:{" "}
          {formatDateWindow(load.deliveryStart, load.deliveryEnd)}
        </span>
      </div>
    </React.Fragment>
  );
};
